<template>
    <div>
        <div :id='id'>
            <div v-if="mapboxError">Errore</div>
        </div>
        <div class="loader-overlay loader-overlay-map" :class="{ 'is-hidden': ! loading }">
            <div class="lds-ripple"><div></div><div></div></div>
        </div>

        <slot name="extra"></slot>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            default: function() {
                return Math.random().toString(36).substring(4)
            }
        },

        options: {
            type: Object,
            required: true
        },

        loading: {
            type: Boolean,
            default: false
        },

        section: {
            type: String,
            required: false,
        },
    },

    computed: {
        lang() {
            return this.$root.lang.tecnomap
        },
    },

    data() {
        return {
            mapboxLoading: false,
            mapboxError: false
        }
    },

    watch: {
        mapboxLoading(value) {
            if(value && ! this.isEstateDetail()) {
                // window.isLoading()
            }
            else {
                window.stopLoading()
            }
        },
    },

    methods: {
        isEstateDetail() {
            return window.route == 'estates-show'
        },

        loadSuccess(event) 
        {
            if(event.detail.container == this.id)
            {
                // console.log('tecnomap.load.success', event)
                this.mapboxLoading = false
                this.mapboxError = false
                this.$emit('ready')
            }
        },

        loadError(event) 
        {
            if(event.detail.container == this.id)
            {
                // console.log('tecnomap.load.error', event)
                this.mapboxLoading = false
                this.mapboxError = true
                this.$emit('error')
            }
        }
    },

    created() {
        // console.log('Portale/Maps/Tecnomap - created', this.id)
        // this.options.modules.poi.lang = this.lang
        
        if (this.options.modules.poi) {
            this.options.modules.poi.lang = this.lang.points_of_interest
        }
        
        window.addEventListener('tecnomap.load.success', this.loadSuccess)
        window.addEventListener('tecnomap.load.error', this.loadError)
    },

    mounted()
    {
        // console.log('Portale/Maps/Map - mounted')
        this.mapboxLoading = true

        if(window.aMaps == undefined)
        {
            window.addEventListener('tecnomap.loaded', () => {
                window.dispatchEvent(new CustomEvent('tecnomap.createMap', { detail: { id: this.id, options: this.options }}))
            }, {once: true});
        }
        else
        {
            window.dispatchEvent(new CustomEvent('tecnomap.createMap', { detail: { id: this.id, options: this.options }}))
        }
    },

    beforeDestroy() {
        // console.log('Portale/Maps/Map - beforeDestroy', this.id)
        window.dispatchEvent(new CustomEvent('tecnomap.destroyMap', { detail: { id: this.id }}))
        window.removeEventListener('tecnomap.load.success', this.loadSuccess)
        window.removeEventListener('tecnomap.load.error', this.loadError)
        this.$emit('destroy')
    }
}
</script>

<style lang="sass">
    .mapboxgl-ctrl.mapboxgl-ctrl-attrib.mapboxgl-compact
        position: absolute
        bottom: 0
        right: 0
        white-space: nowrap
</style>
